(() => {
  const init = (root) => {
    if (!root || root.dataset.tabsReady === 'true') return;
    const tabs = [...root.querySelectorAll('[data-tab-button]')];
    const panels = [...root.querySelectorAll('[data-tab-panel]')];
    if (!tabs.length) return;
    root.dataset.tabsReady = 'true';

    const activate = (tab, focus = false) => {
      const panelId = tab.dataset.panelId;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        const active = panel.id === panelId;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      if (focus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        activate(tabs[nextIndex], true);
      });
    });

    root.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-tabs-product-form]');
      if (!form || !root.contains(form)) return;
      event.preventDefault();
      const button = form.querySelector('.lumina-tabs__add');
      if (!button || button.disabled) return;

      const original = button.dataset.addLabel || button.textContent.trim();
      button.disabled = true;
      button.classList.remove('is-added', 'is-error');
      button.textContent = 'ADDING…';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        if (!response.ok) throw new Error('Add failed');
        const item = await response.json();
        button.textContent = 'ADDED ✓';
        button.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { item } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { item } }));
        window.setTimeout(() => {
          button.textContent = original;
          button.classList.remove('is-added');
          button.disabled = false;
        }, 1500);
      } catch (error) {
        button.textContent = 'TRY AGAIN';
        button.classList.add('is-error');
        window.setTimeout(() => {
          button.textContent = original;
          button.classList.remove('is-error');
          button.disabled = false;
        }, 1800);
      }
    });
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-lumina-tabs]')) init(scope);
    scope.querySelectorAll?.('[data-lumina-tabs]').forEach(init);
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => initAll())
    : initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
